export function getItem(key: string): any {
  const token = window.localStorage.getItem(key);
  if (token) {
    return token;
  }

  return null;
}
